import Resource from '../../resource';
import request from '../../../utils/request';

class Excuse extends Resource {
    constructor() {
        super('excuses');
    }

    getLookups() {
      return request({
        url: `/excuses/get_lookups`,
        method: 'get',
      });
    }

    put(id, query) {
      let url='';
      id != null ? url=`/excuses/${id}` : url = `/excuses`;
      return request({
          url: url,
          method: 'POST',
          data: query,
      })
    }

    updateStatus(id, payment_status_id, query) {
      return request({
          url: payment_status_id == 0 ? `/excuses/${id}` : `/excuses/update_status/${id}`,
          method: payment_status_id == 0 ? 'delete' : 'post',
          data: query,
      })
    }
}

export {Excuse as default};
